"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Indicator = _interopRequireDefault(require("./Indicator"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var _default = function _default(_ref) {
  var score = _ref.score;
  return /*#__PURE__*/_react.default.createElement(_Indicator.default, {
    bgColor: "#F29503",
    color: "#FFFFFF",
    title: "Score",
    text: score
  });
};
exports.default = _default;